<template>
  <v-form ref="form">
    <v-row class="py-3">
      <v-col md="9">
        <div class="tertiary--text text-body-2">
          {{
            $t(
              'fleet_management.agents.create.labels.create_agent_form_temperature_sensor_maximum_percentage'
            )
          }}
        </div>
        <v-text-field
          id="idEventosTemperaturaMaximaMotor"
          v-model.number="max_temp"
          dense
          filled
          min="0"
          max="190"
          :readonly="!editMode"
          hide-details="auto"
          :error-messages="maxErrorMessage"
          :error="inputError"
          :rules="maxEngineTemperatureRules"
          type="number"
          @input="engineTemperatureInput"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { i18n } from '@leapsight/portal'

export default {
  name: 'EngineTemperature',
  props: {
    engineTemp: Object,
    editMode: Boolean
  },
  data() {
    return {
      max_temp: 145,
      maxEngineTemperatureRules: [
        v =>
          (v !== null && v !== undefined && v !== '') ||
          i18n.t('fleet_management.agents.create.errors.temperature_sensor_empty'),
        v =>
          (v >= 0 && v <= 190) ||
          i18n.t('fleet_management.agents.create.errors.engine_temperature_sensor_maximum_range_error')
      ],
      maxErrorMessage: '',
      inputError: null
    }
  },
  methods: {
    engineTemperatureInput() {
      const engineTemperatureObject = {}
      engineTemperatureObject['max_temp'] = parseFloat(this.max_temp)
      this.$emit('engineTemp', engineTemperatureObject)
      this.validationsEngineTemperature()

      if (this.max_temp !== '') this.$refs.form.validate()
    },
    validationsEngineTemperature() {
      const engTemp = parseFloat(this.max_temp)
      const validEngineTemperatureValues = engTemp >= 0 && engTemp <= 190

      this.$emit('engineTemperatureValid', validEngineTemperatureValues)
    }
  },
  mounted() {
    if (this.engineTemp) {
      const engineTemperatureObject = new Object()
      engineTemperatureObject['max_temp'] = parseFloat(
        this.engineTemp.max_temp
      ).toFixed(1)
    }
    this.engineTemperatureInput()
  },
  watch: {
    editMode() {
      if (!this.editMode) {
        this.max_temp = Number(this.engineTemp.max_temp).toFixed(1)
      }
    },
    engineTemp: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.max_temp = parseFloat(newVal.max_temp).toFixed(1)
        }
      }
    }
  }
}
</script>